export * from './hasItemInArray';
export * from './mapAsync';
export const EMPTY_ARRAY = Object.freeze([]) as any[];
